<div class="workbie-payouts-container">
  <!-- Header -->
  <div class="header">
    <h1>Pagos a Workbies</h1>
    <p class="subtitle">Gestión y trazabilidad de pagos pendientes y realizados</p>
  </div>

  <!-- ==================== Tarjetas de resumen ==================== -->
  <div *ngIf="errorSummary" class="error-card">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ errorSummary }}</span>
  </div>

  <div *ngIf="loadingSummary" class="loading-container summary-loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <div *ngIf="!loadingSummary && summary" class="summary-cards">
    <mat-card class="summary-card total-pending">
      <div class="summary-icon">
        <mat-icon>account_balance_wallet</mat-icon>
      </div>
      <div class="summary-content">
        <span class="summary-label">Total por pagar</span>
        <span class="summary-value">{{ formatCurrency(summary.totalPendingAmount) }}</span>
        <span class="summary-detail">{{ summary.pendingWorkbies }} workbies · {{ summary.pendingJobs }} trabajos</span>
      </div>
    </mat-card>

    <mat-card class="summary-card overdue-week">
      <div class="summary-icon">
        <mat-icon>schedule</mat-icon>
      </div>
      <div class="summary-content">
        <span class="summary-label">Semana vencida</span>
        <span class="summary-value">{{ formatCurrency(summary.lastWeekPendingAmount) }}</span>
        <span class="summary-detail">Pagos pendientes de la semana anterior</span>
      </div>
    </mat-card>

    <mat-card class="summary-card paid-month">
      <div class="summary-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="summary-content">
        <span class="summary-label">Pagado este mes</span>
        <span class="summary-value">{{ formatCurrency(summary.totalPaidThisMonth) }}</span>
        <span class="summary-detail">{{ summary.paidJobsThisMonth }} trabajos pagados</span>
      </div>
    </mat-card>
  </div>

  <!-- ==================== Tabs ==================== -->
  <mat-tab-group class="payouts-tabs" [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">

    <!-- ---------- Pendientes ---------- -->
    <mat-tab label="Pendientes">
      <div class="tab-content">
        <div *ngIf="errorPending" class="error-card">
          <mat-icon color="warn">error</mat-icon>
          <span>{{ errorPending }}</span>
        </div>

        <div *ngIf="loadingPending" class="loading-container">
          <mat-spinner></mat-spinner>
          <p>Cargando pagos pendientes...</p>
        </div>

        <div *ngIf="!loadingPending && !errorPending" class="table-container">
          <table mat-table [dataSource]="pendingList" class="payouts-table" *ngIf="pendingList.length > 0">

            <!-- Workbie Info Column -->
            <ng-container matColumnDef="workbieInfo">
              <th mat-header-cell *matHeaderCellDef>Workbie</th>
              <td mat-cell *matCellDef="let item">
                <div class="workbie-info-cell">
                  <mat-icon>person</mat-icon>
                  <div class="workbie-name">
                    <strong>{{ item.userFirstName }} {{ item.userLastName }}</strong>
                    <span class="info-text">{{ item.userEmail || 'N/A' }}</span>
                    <span class="info-text">{{ item.userPhoneNumber || 'N/A' }}</span>
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- Job Count Column -->
            <ng-container matColumnDef="jobCount">
              <th mat-header-cell *matHeaderCellDef>Trabajos</th>
              <td mat-cell *matCellDef="let item">
                <div class="count-badge">
                  <mat-icon>work</mat-icon>
                  <strong>{{ item.jobCount }}</strong>
                </div>
              </td>
            </ng-container>

            <!-- Total Amount Column -->
            <ng-container matColumnDef="totalAmount">
              <th mat-header-cell *matHeaderCellDef>Total a Pagar</th>
              <td mat-cell *matCellDef="let item">
                <div class="amount-cell">
                  <strong>{{ formatCurrency(item.totalAmount) }}</strong>
                </div>
              </td>
            </ng-container>

            <!-- Pending Since Column -->
            <ng-container matColumnDef="pendingSince">
              <th mat-header-cell *matHeaderCellDef>Pendiente desde</th>
              <td mat-cell *matCellDef="let item">
                <span class="pending-since" [class.overdue]="isOverdue(item.oldestCreatedAt)">
                  <mat-icon *ngIf="isOverdue(item.oldestCreatedAt)">warning</mat-icon>
                  {{ formatDateOnly(item.oldestCreatedAt) }}
                </span>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let item">
                <button mat-raised-button color="primary" (click)="viewPayoutDetails(item.workbieUserId)">
                  <mat-icon>visibility</mat-icon>
                  Ver Detalle
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedPendingColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedPendingColumns;" class="table-row"></tr>
          </table>

          <div *ngIf="pendingList.length === 0" class="empty-state">
            <mat-icon>celebration</mat-icon>
            <p>No hay pagos pendientes 🎉</p>
          </div>
        </div>

        <mat-paginator
          *ngIf="!loadingPending && pendingList.length > 0"
          [length]="pendingTotalElements"
          [pageSize]="pendingPageSize"
          [pageIndex]="pendingPage"
          [pageSizeOptions]="[5, 10, 25, 50]"
          (page)="onPendingPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-tab>

    <!-- ---------- Pagados ---------- -->
    <mat-tab label="Pagados">
      <div class="tab-content">
        <!-- Filtro por rango de fechas -->
        <div class="filter-bar">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Desde</mat-label>
            <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filterFrom">
            <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Hasta</mat-label>
            <input matInput [matDatepicker]="toPicker" [(ngModel)]="filterTo">
            <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>

          <button mat-raised-button color="primary" (click)="applyPaidFilter()">
            <mat-icon>filter_alt</mat-icon>
            Filtrar
          </button>

          <button mat-stroked-button *ngIf="hasPaidFilter()" (click)="clearPaidFilter()">
            <mat-icon>close</mat-icon>
            Limpiar
          </button>
        </div>

        <div *ngIf="errorPaid" class="error-card">
          <mat-icon color="warn">error</mat-icon>
          <span>{{ errorPaid }}</span>
        </div>

        <div *ngIf="loadingPaid" class="loading-container">
          <mat-spinner></mat-spinner>
          <p>Cargando pagos realizados...</p>
        </div>

        <div *ngIf="!loadingPaid && !errorPaid" class="table-container">
          <table mat-table [dataSource]="paidList" class="payouts-table" *ngIf="paidList.length > 0">

            <!-- Workbie Info Column -->
            <ng-container matColumnDef="workbieInfo">
              <th mat-header-cell *matHeaderCellDef>Workbie</th>
              <td mat-cell *matCellDef="let item">
                <div class="workbie-info-cell">
                  <mat-icon>person</mat-icon>
                  <div class="workbie-name">
                    <strong>{{ item.workbieName }}</strong>
                    <span class="info-text">{{ item.userEmail || 'N/A' }}</span>
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- Original Amount Column -->
            <ng-container matColumnDef="originalAmount">
              <th mat-header-cell *matHeaderCellDef>Monto Original</th>
              <td mat-cell *matCellDef="let item">
                <span class="info-text">{{ formatCurrency(item.originalAmount) }}</span>
              </td>
            </ng-container>

            <!-- Total Amount (paid) Column -->
            <ng-container matColumnDef="totalAmount">
              <th mat-header-cell *matHeaderCellDef>Monto Pagado</th>
              <td mat-cell *matCellDef="let item">
                <div class="amount-cell">
                  <strong>{{ formatCurrency(item.totalAmount) }}</strong>
                </div>
              </td>
            </ng-container>

            <!-- Paid At Column -->
            <ng-container matColumnDef="paidAt">
              <th mat-header-cell *matHeaderCellDef>Fecha de Pago</th>
              <td mat-cell *matCellDef="let item">
                <span class="info-text">{{ formatDate(item.paidAt) }}</span>
              </td>
            </ng-container>

            <!-- Provider / Reference Column -->
            <ng-container matColumnDef="provider">
              <th mat-header-cell *matHeaderCellDef>Proveedor / Referencia</th>
              <td mat-cell *matCellDef="let item">
                <div class="provider-cell" *ngIf="item.provider || item.providerTransferId; else noProvider">
                  <span *ngIf="item.provider">{{ item.provider }}</span>
                  <span class="provider-ref" *ngIf="item.providerTransferId">{{ item.providerTransferId }}</span>
                </div>
                <ng-template #noProvider>
                  <span class="info-text">N/A</span>
                </ng-template>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedPaidColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedPaidColumns;" class="table-row"></tr>
          </table>

          <div *ngIf="paidList.length === 0" class="empty-state">
            <mat-icon>inbox</mat-icon>
            <p>{{ hasPaidFilter() ? 'Sin pagos en este rango' : 'Aún no hay pagos registrados' }}</p>
          </div>
        </div>

        <mat-paginator
          *ngIf="!loadingPaid && paidList.length > 0"
          [length]="paidTotalElements"
          [pageSize]="paidPageSize"
          [pageIndex]="paidPage"
          [pageSizeOptions]="[5, 10, 25, 50]"
          (page)="onPaidPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-tab>
  </mat-tab-group>

  <!-- ==================== Detail Modal ==================== -->
  <div *ngIf="selectedDetail" class="modal-overlay" (click)="closeDetailModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>
          <mat-icon>assignment</mat-icon>
          Detalle de Pagos - {{ selectedDetail.userInfo.firstName }} {{ selectedDetail.userInfo.lastName }}
        </h2>
        <button mat-icon-button (click)="closeDetailModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div *ngIf="error" class="error-card modal-error">
        <mat-icon color="warn">error</mat-icon>
        <span>{{ error }}</span>
      </div>

      <div *ngIf="loadingDetail" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando detalles...</p>
      </div>

      <div *ngIf="!loadingDetail" class="modal-body">
        <!-- User Information Section -->
        <div class="detail-section">
          <h3>
            <mat-icon>person</mat-icon>
            Información del Workbie
          </h3>
          <div class="detail-grid">
            <div class="detail-item">
              <strong>Nombre Completo:</strong>
              <span>{{ selectedDetail.userInfo.firstName }} {{ selectedDetail.userInfo.lastName }}</span>
            </div>
            <div class="detail-item">
              <strong>Email:</strong>
              <span>{{ selectedDetail.userInfo.email || 'N/A' }}</span>
            </div>
            <div class="detail-item">
              <strong>Teléfono:</strong>
              <span>{{ selectedDetail.userInfo.phoneNumber || 'N/A' }}</span>
            </div>
            <div class="detail-item">
              <strong>Documento:</strong>
              <span>{{ selectedDetail.userInfo.documentType }}: {{ selectedDetail.userInfo.document }}</span>
            </div>
          </div>

          <!-- Bank Certification -->
          <div class="bank-cert-section" *ngIf="selectedDetail.bankCertificationUrl">
            <button mat-raised-button color="accent" (click)="openBankCertification(selectedDetail.bankCertificationUrl)">
              <mat-icon>description</mat-icon>
              Ver Certificación Bancaria
            </button>
          </div>
        </div>

        <!-- Total Amount Section -->
        <div class="detail-section total-amount-section">
          <div class="total-amount-box">
            <span class="total-label">Total a Pagar:</span>
            <span class="total-value">{{ formatCurrency(selectedDetail.totalAmountToPay) }}</span>
          </div>
        </div>

        <!-- Jobs List Section -->
        <div class="detail-section">
          <h3>
            <mat-icon>work</mat-icon>
            Trabajos Pendientes ({{ selectedDetail.jobs.length }})
          </h3>

          <div class="jobs-list">
            <mat-card *ngFor="let job of selectedDetail.jobs" class="job-card">
              <div class="job-header">
                <div class="job-category">
                  <mat-icon>category</mat-icon>
                  <div>
                    <strong>{{ job.categoryName }}</strong>
                    <span class="subcategory">{{ job.subcategoryName }}</span>
                  </div>
                </div>
                <div class="job-amount">
                  {{ formatCurrency(job.totalAmount) }}
                </div>
              </div>

              <div class="job-details">
                <div class="job-detail-item">
                  <mat-icon>event</mat-icon>
                  <span>{{ formatDate(job.dateInit) }}</span>
                </div>
                <div class="job-detail-item">
                  <mat-icon>person_outline</mat-icon>
                  <span>Cliente: {{ job.clientNameMasked }}</span>
                </div>
                <div class="job-detail-item">
                  <mat-icon>info</mat-icon>
                  <span>Estado: {{ job.statusName }}</span>
                </div>
                <div class="job-detail-item job-id">
                  <mat-icon>tag</mat-icon>
                  <span class="id-text">{{ job.idPayout }}</span>
                </div>
              </div>

              <!-- Desglose del cobro/pago -->
              <mat-expansion-panel class="breakdown-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>receipt_long</mat-icon>
                    Ver desglose
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="breakdown-grid">
                  <!-- Lo que pagó el cliente -->
                  <div class="breakdown-column client-column">
                    <h4>Lo que pagó el cliente</h4>
                    <div class="breakdown-row">
                      <span>Valor del servicio</span>
                      <strong>{{ formatCurrency(job.serviceValue) }}</strong>
                    </div>
                    <div class="breakdown-row" *ngFor="let concept of job.clientConcepts">
                      <span>{{ concept.name }}</span>
                      <strong [class.amount-negative]="concept.value < 0" [class.amount-positive]="concept.value > 0">
                        {{ formatSignedCurrency(concept.value) }}
                      </strong>
                    </div>
                    <div class="breakdown-row" *ngIf="job.creditApplied > 0">
                      <span>Créditos aplicados</span>
                      <strong class="amount-negative">-{{ formatCurrency(job.creditApplied) }}</strong>
                    </div>
                    <div
                      class="breakdown-row"
                      *ngIf="job.clientAdjustment !== 0"
                      matTooltip="Descuentos aplicados al cobro que no quedaron registrados por concepto">
                      <span>
                        Descuentos no desglosados
                        <mat-icon class="hint-icon">info_outline</mat-icon>
                      </span>
                      <strong [class.amount-negative]="job.clientAdjustment < 0" [class.amount-positive]="job.clientAdjustment > 0">
                        {{ formatSignedCurrency(job.clientAdjustment) }}
                      </strong>
                    </div>
                    <div class="breakdown-row breakdown-total">
                      <span>Total pagado por el cliente</span>
                      <strong>{{ formatCurrency(job.clientPaid) }}</strong>
                    </div>
                  </div>

                  <!-- Lo que pagamos al workbie -->
                  <div class="breakdown-column workbie-column">
                    <h4>Lo que pagamos al workbie</h4>
                    <div class="breakdown-row" *ngFor="let concept of job.workbieConcepts">
                      <span>{{ concept.name }}</span>
                      <strong [class.amount-negative]="concept.value < 0" [class.amount-positive]="concept.value > 0">
                        {{ formatSignedCurrency(concept.value) }}
                      </strong>
                    </div>
                    <div class="breakdown-row breakdown-total">
                      <span>Total a pagar al workbie</span>
                      <strong>{{ formatCurrency(job.totalAmount) }}</strong>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-card>
          </div>
        </div>

        <!-- Payment Form Section -->
        <div class="detail-section payment-section">
          <h3>
            <mat-icon>payment</mat-icon>
            Procesar Pago
          </h3>

          <div class="payment-form">
            <!-- Amount Input -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Monto a Pagar</mat-label>
              <input
                matInput
                type="number"
                [(ngModel)]="paymentAmount"
                [max]="selectedDetail.totalAmountToPay"
                min="0"
                step="0.01"
                placeholder="Ingrese el monto">
              <mat-icon matPrefix>attach_money</mat-icon>
              <mat-hint>Máximo: {{ formatCurrency(selectedDetail.totalAmountToPay) }}</mat-hint>
              <mat-error *ngIf="paymentAmount > selectedDetail.totalAmountToPay">
                El monto no puede superar el total a pagar
              </mat-error>
            </mat-form-field>

            <!-- Observation Input -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Observaciones</mat-label>
              <textarea
                matInput
                [(ngModel)]="paymentObservation"
                rows="3"
                placeholder="Ingrese observaciones (opcional)">
              </textarea>
              <mat-icon matPrefix>note</mat-icon>
            </mat-form-field>

            <!-- File Upload -->
            <div class="file-upload-section">
              <label class="file-upload-label">
                <mat-icon>attach_file</mat-icon>
                Archivos de Soporte (Requerido)
              </label>

              <input
                type="file"
                #fileInput
                multiple
                accept=".pdf,.jpg,.jpeg,.png"
                (change)="onFilesSelected($event)"
                style="display: none;">

              <button
                mat-stroked-button
                color="primary"
                (click)="fileInput.click()"
                type="button">
                <mat-icon>cloud_upload</mat-icon>
                Seleccionar Archivos
              </button>

              <!-- Selected Files List -->
              <div class="selected-files" *ngIf="selectedFiles.length > 0">
                <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                  <mat-icon>description</mat-icon>
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">({{ (file.size / 1024).toFixed(2) }} KB)</span>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="removeFile(i)"
                    type="button">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>

              <p class="file-hint" *ngIf="selectedFiles.length === 0">
                <mat-icon>info</mat-icon>
                Debe subir al menos un archivo de soporte
              </p>
            </div>

            <!-- Payment Summary -->
            <div class="payment-summary">
              <div class="summary-row">
                <span>Total del Servicio:</span>
                <strong>{{ formatCurrency(selectedDetail.totalAmountToPay) }}</strong>
              </div>
              <div class="summary-row">
                <span>Monto a Pagar:</span>
                <strong class="payment-amount">{{ formatCurrency(paymentAmount) }}</strong>
              </div>
              <div class="summary-row" *ngIf="paymentAmount < selectedDetail.totalAmountToPay">
                <span>Saldo Pendiente:</span>
                <strong class="pending-amount">{{ formatCurrency(selectedDetail.totalAmountToPay - paymentAmount) }}</strong>
              </div>
              <div class="summary-row">
                <span>Trabajos a Pagar:</span>
                <strong>{{ selectedDetail.jobs.length }}</strong>
              </div>
              <div class="summary-row">
                <span>Archivos Adjuntos:</span>
                <strong>{{ selectedFiles.length }}</strong>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="payment-actions">
              <button
                mat-raised-button
                color="primary"
                [disabled]="!isPaymentValid() || processingPayment"
                (click)="processPayment()">
                <mat-spinner diameter="20" *ngIf="processingPayment"></mat-spinner>
                <mat-icon *ngIf="!processingPayment">check_circle</mat-icon>
                {{ processingPayment ? 'Procesando...' : 'Procesar Pago' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
